module.exports = function () {
    var $downloadLink = $('.download-link');

    if (!$downloadLink.length) {
        return;
    }

    var url = $downloadLink.attr('href');
    var filename = $downloadLink.data('filename');

    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isIE) {
        var downloadCallback = function () {
            var blobObject = this.response;
            window.navigator.msSaveBlob(blobObject, filename);
        };

        var a = new XMLHttpRequest();
        a.addEventListener('load', downloadCallback, false);
        a.open('get', url, true);
        a.responseType = 'blob';
        a.send();
    }
    else if (isIOS) {
        window.location.href = url;
    }
    else {
        $downloadLink[0].click();
    }
}